import { observer } from 'mobx-react-lite'
import { useInjection } from '@core/providers/inversify-react.provider'
import { VersionPresenter } from './version.presenter'

export const VersionBannerComponent = observer(() => {
  const presenter: VersionPresenter = useInjection(VersionPresenter)
  const vm = presenter.viewModel

  if (!vm.showVersionBanner) return null

  // No own fixed positioning — see OfflineBannerComponent's note.
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-shell-accent px-4 py-2 text-center text-sm font-medium text-white">
      <span>{vm.message}</span>
      <button
        type="button"
        onClick={() => presenter.reload()}
        className="shrink-0 rounded-md bg-white/20 px-2 py-0.5 font-semibold hover:bg-white/30"
      >
        {vm.reloadLabel}
      </button>
    </div>
  )
})
